import authenticationApi from './authenticationApi';

export default async function fetchAccessCode(email: string) {
  await authenticationApi.get(`/access-code?email=${email}`);
}
